import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageSelectorComponent } from './shared/components/language-selector/language-selector.component';
import { I18nService } from './core/services/i18n.service';

/**
 * Root App Component
 * Entry point for the application
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LanguageSelectorComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private i18nService = inject(I18nService);

  ngOnInit(): void {
    // Initialize i18n service
    this.i18nService.getCurrentLanguage();
  }
}
